import React, { useEffect } from "react";
import { View, StyleSheet } from "react-native";
import { useRoute } from "@react-navigation/native";
import { RootRouteProps } from "routers/types/stack";

import {
  Button,
  Header,
  Loading,
  SafeLayout,
  Permissions,
  ScrollLayout,
  Error,
} from "components";

import { useForm, Controller } from "react-hook-form";

import { sizes, strings } from "assets/constants";
import {
  useGetEmployeePermissions,
  useUpdateEmployeePermissions,
} from "clients/apis";
import { _goToBack } from "routers/helper";
import { isEqualArrays } from "utils";

const EmployeePermissions = () => {
  const { user_id, name } =
    useRoute<RootRouteProps<"employee_permissions">>().params;

  const { isLoading, data, error, isError, refetch, isRefetching } =
    useGetEmployeePermissions({
      user_id,
    });

  const updateEmployeePermissionsMut = useUpdateEmployeePermissions();

  const { control, setValue, getValues, handleSubmit } = useForm<{
    user_id: number;
    permissions: Array<number>;
  }>({
    defaultValues: {
      user_id,
      permissions: data?.data?.Data?.map((e: any) => e?.id) || [],
    },
  });

  useEffect(() => {
    setValue("permissions", data?.data?.Data?.map((e: any) => e?.id) || []);
  }, [data?.data?.Data]);

  const _onSubmit = () => {
    const prevPermissions = data?.data?.Data?.map((e: any) => e?.id) || [];

    if (isEqualArrays(prevPermissions, getValues().permissions)) {
      _goToBack();
    } else {
      updateEmployeePermissionsMut.mutate(getValues());
    }
  };

  const _renderContent = () => {
    if (isLoading) {
      return <Loading />;
    }

    if (isError) {
      return <Error error={error} reset={refetch} loading={isRefetching} />;
    }

    return (
      <View style={styles.container}>
        <Controller
          control={control}
          name="permissions"
          render={({ field: { value, onChange } }) => (
            <Permissions defaults={value} onChange={onChange} />
          )}
        />

        <Button
          onPress={handleSubmit(_onSubmit)}
          title={{ value: strings.confirm }}
          loading={updateEmployeePermissionsMut?.isLoading}
        />
      </View>
    );
  };

  return (
    <>
      <Header title={strings.user_permissions(name)} />

      <SafeLayout style={{ padding: 0 }}>
        <ScrollLayout contentContainerStyle={{ paddingHorizontal: 0 }}>
          {_renderContent()}
        </ScrollLayout>
      </SafeLayout>
    </>
  );
};

export default EmployeePermissions;

const styles = StyleSheet.create({ container: { padding: sizes.space } });
